const EXCEPTIONS = {
  ['site diary']: 'site diaries',
  ['timesheet entry']: 'timesheet entries',
  address: 'addresses',
  ['email address']: 'email addresses',
  entry: 'entries',
  is: 'are',
  priority: 'priorities',
  sheep: 'sheep',
  status: 'statuses',
  company: 'companies',
  SWMS: 'SWMS', // no change
  swms: 'SWMS', // no change
  SDS: 'SDS', // no change
  sds: 'SDS', // no change
  staff: 'staff', // no change
  this: 'these',
}

/**
 * Uses the provided count to determine whether to pluralise the word
 * @param count the number of items
 * @param word the word in SINGULAR form
 * @returns the count + either the word provided if count is 1, or the plural form of the word
 */
export const pluralise = (count = 0, word: string): string => {
  if (count === 1) return `${count} ${word}`

  const exception = EXCEPTIONS[word] ?? EXCEPTIONS[word.toLowerCase()]
  if (exception) return `${count} ${exception}`

  return `${count} ${word}s`
}

/**
 * Uses the provided count to determine whether to pluralise the word
 * @param count the number of items
 * @param word the word in SINGULAR form
 * @returns either the word provided if count is 1, or the plural form of the word
 */
export const pluraliseWord = (count = 0, word: string): string => {
  if (count === 1) return word

  if (word.toString().toLowerCase().endsWith('s')) return word

  const exception = EXCEPTIONS[word.toLowerCase()]
  if (exception) return exception

  return `${word}s`
}

export const pluraliseName = (name: string): string => {
  if (!name?.length) return name

  const lastLetter = name[name.length - 1].toLowerCase()
  if (lastLetter === 's') return name + "'" // e.g. "Chris'" instead of "Chris's"

  return name + "'s"
}

export const pastTense = (word: string): string => {
  if (word.endsWith('ed')) {
    return word
  }

  if (word.endsWith('e')) {
    return word + 'd'
  }

  return word + 'ed'
}
